@if (sections()) {
  <section class="content-layout content-layout-9">
    <div class="container">
      <div class="row">
        @if (breakpoints() === "mobile") {
          <div class="col-xs-12">
            <ng-container *ngTemplateOutlet="menuTemplate"></ng-container>
            <ng-container *ngTemplateOutlet="contentTemplate; context: { sections: sections() }"></ng-container>
          </div>
        } @else {
          <aside class="col-lg-3">
            <ng-container *ngTemplateOutlet="menuTemplate"></ng-container>
          </aside>
          <div class="col-lg-8 col-lg-offset-1">
            <ng-container *ngTemplateOutlet="contentTemplate; context: { sections: sections() }"></ng-container>
          </div>
        }
        <ng-template #menuTemplate>
          @if (menu().length > 0) {
            <ul class="links">
              @for (m of menu(); track m) {
                <li (click)="goToSection(m.anchor)" class="link">
                  <hr class="link-separator" />
                  @if (m.anchor && m.label) {
                    <span>
                      {{ m.label }}
                      <i [iconName]="'ARROW_DOWN'" color="ANCHOR" size="1.6rem"></i>
                    </span>
                  }
                </li>
              }
            </ul>
          }
        </ng-template>
        <ng-template #contentTemplate let-sections="sections">
          @for (section of sections; track section) {
            <div [id]="section.anchor">
              @switch (section.type) {
                @case ("bloc_article_html") {
                  @if (section.data?.titleFormatted; as title) {
                    <app-title [titles]="[title]" class="title" />
                  }
                  <div [innerHTML]="section.data.html" class="paragraph"></div>
                }
                @case ("bloc_article_image") {
                  <figure class="figure">
                    @if (section.data.image) {
                      <app-image [image]="section.data.image" [size]="{ dh: 430, mh: 200 }" />
                    }
                    @if (section.data.legend; as legend) {
                      <figcaption>
                        <hr class="separator" />
                        <p [innerHTML]="legend" class="legend"></p>
                      </figcaption>
                    }
                  </figure>
                }
                @case ("bloc_article_video") {
                  <div>
                    <figure class="figure">
                      @if (section.data.video; as video) {
                        <app-video [mp4Url]="video.mp4Url" [previewImage]="video.image" [style]="{ width: '100%' }" />
                      }
                      @if (section.data.legend; as legend) {
                        <figcaption>
                          <hr class="separator" />
                          <p [innerHTML]="legend" class="legend"></p>
                        </figcaption>
                      }
                    </figure>
                  </div>
                }
              }
            </div>
          }
        </ng-template>
      </div>
    </div>
  </section>
}
